import {Room} from '@vio/core/src/room/types/room'

import {COMPACT_ROOMS_AMOUNT} from '../../components/Accommodation/Rooms/constants'

export const getScrollTargetSpecificRoom = (roomId: string) =>
  `scrollToTarget-roomCard-${roomId}`

/**
 * Finds the room that holds the offer, and whether the compact rooms list has to expand to show it.
 * @param rooms - rooms in display order
 * @param offerId - the offer to look for
 * @returns the matching room, if any, and whether it sits past the compact list
 */
export const getRoomForOffer = (
  rooms: Room[],
  offerId?: string
): {room?: Room; shouldExpandRooms: boolean} => {
  const roomIndex = offerId
    ? rooms.findIndex(room => room.offers.some(offer => offer.id === offerId))
    : -1

  return {
    room: rooms[roomIndex],
    shouldExpandRooms: roomIndex >= COMPACT_ROOMS_AMOUNT
  }
}
